import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import IcoClose from '../../assets/images/button/ico-pop-close-black.svg';
import Input from '../atoms/Input';
import Button from '../atoms/Button';
import { useSiteMemoEdit } from '../../hooks/RQuery/utils/sites';

const OverlaySt = {
  Wrap: styled.div`
    position: relative;
    min-width: 313px;
    border-radius: 10px;
    padding: 20px;
    background: #fff;
    box-shadow: 1px 1px 10px 0 #00000066;

    &:after {
      position: absolute;
      left: 50%;
      top: 100%;
      content: '';
      border: 12px solid transparent;
      border-left: 12px solid #fff;
      border-radius: 5px;
      border-top: 12px solid #fff;
      transform: translate(-50%, -15px) rotate(-135deg) skew(10deg, 10deg);
    }
  `,
  Head: styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
  `,
  Close: styled.button`
    width: 24px;
    height: 24px;
    background: url(${IcoClose}) no-repeat center;
  `,
  Alias: styled.strong`
    color: #3baac3;
    font-size: 16px;
    font-weight: 700;
    margin-right: 12px;
  `,
  Name: styled.p`
    color: #7c868f;
    font-size: 16px;
    font-weight: 500;
  `,
  Address: styled.p`
    color: #192640;
    font-weight: 500;
    font-size: 16px;
  `,
  Memo: styled.p`
    font-size: 14px;
    font-weight: 400;
    color: #000;
    margin: 4px 0;
  `,
  BtnArea: styled.div`
    margin-top: 4px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    button {
      &:not(:last-child) {
        margin-right: 4px;
      }
    }
  `,
};

const MapOverlay = ({ data, onClose, siteId }) => {
  const [memo, setMemo] = useState('');
  const [isEdit, setIsEdit] = useState(false);
  const editMemo = useSiteMemoEdit({ siteId });
  const onEditMemo = () => {
    editMemo.mutate(
      { memo },
      {
        onSuccess: () => setIsEdit(!isEdit),
      },
    );
  };
  const onChange = (e) => {
    setMemo(e.target.value);
  };
  useEffect(() => {
    setMemo(data?.memo);
  }, [data]);
  return (
    <OverlaySt.Wrap id={'siteOverlay'}>
      <OverlaySt.Head>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <OverlaySt.Alias>{data?.siteAlias}</OverlaySt.Alias>
          <OverlaySt.Name>{data?.siteName}</OverlaySt.Name>
        </div>
        <OverlaySt.Close type={'button'} onClick={onClose}>
          <span className={'hidden'}>닫기</span>
        </OverlaySt.Close>
      </OverlaySt.Head>
      <OverlaySt.Address>{data?.siteAddress}</OverlaySt.Address>
      <OverlaySt.Memo>메모</OverlaySt.Memo>
      <Input width={'full'} height={48} value={memo} readOnly={!isEdit} onChange={onChange} />
      <OverlaySt.BtnArea>
        {isEdit ? (
          <>
            <Button $colorType={'white'} text={'취소'} width={58} height={36} onClick={() => setIsEdit(!isEdit)} />
            <Button $colorType={'peacock'} text={'저장'} width={58} height={36} onClick={onEditMemo} />
          </>
        ) : (
          <Button $colorType={'peacock'} text={'수정'} width={58} height={36} onClick={() => setIsEdit(!isEdit)} />
        )}
      </OverlaySt.BtnArea>
    </OverlaySt.Wrap>
  );
};

export default MapOverlay;
